module.exports = __webpack_public_path__ + "static/media/29.204451b3.mp3";